<template>
  <vs-popup class="customer-sample-order-create-popup"
            id="popup"
            title="UPDATE CUSTOMER SAMPLE ORDER"
            @close="open = false"
            :active.sync="open"
            :buttons-hidden="true">
    <vx-card no-shadow>

      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(onClickCreateSampleOrder)" autocomplete="off">

          <div class="vx-row mb-3">
            <div class="vx-col md:w-full w-full md:mb-0">
              <ValidationProvider vid="formulation_items" name="formulation_items" rules="" v-slot="{ errors }">
                <small class="label">Select a delivery address to change</small>
                <v-select
                  v-on:input="onChangeSelectDeliveryAddress"
                  @search="onSearch"
                  name="formulation_items" placeholder=""
                  :reduce="option => option"
                  label="country"
                  :options="addresses" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                  <template slot="option" slot-scope="option">
                    <div class="d-center">
                      <span style="font-weight: normal">{{ option.name }}</span> <span v-if="option.name">, </span>
                      <span style="font-weight: normal">{{ option.line1 }}</span> <span v-if="option.line1">, </span>
                      <span style="font-weight: normal">{{ option.line2 }}</span> <span v-if="option.line2">, </span>
                      <span style="font-weight: normal">{{ option.line3 }}</span> <span v-if="option.line3">, </span>
                      <span style="font-weight: normal">{{ option.town_state }}</span> <span v-if="option.town_state">, </span>
                      <span style="font-weight: normal">{{ option.post_code }}</span> <span v-if="option.post_code">, </span>
                      <span style="font-weight: normal">{{ option.country }}</span> <span v-if="option.country">, </span>
                    </div>
                  </template>
                  <template slot="selected-option" slot-scope="option">
                    <div class="selected d-center">
                      <span style="font-weight: normal">{{ option.name }}</span> <span v-if="option.name">, </span>
                      <span style="font-weight: normal">{{ option.line1 }}</span> <span v-if="option.line1">, </span>
                      <span style="font-weight: normal">{{ option.line2 }}</span> <span v-if="option.line2">, </span>
                      <span style="font-weight: normal">{{ option.line3 }}</span> <span v-if="option.line3">, </span>
                      <span style="font-weight: normal">{{ option.town_state }}</span> <span v-if="option.town_state">, </span>
                      <span style="font-weight: normal">{{ option.post_code }}</span> <span v-if="option.post_code">, </span>
                      <span style="font-weight: normal">{{ option.country }}</span> <span v-if="option.country">, </span>
                    </div>
                  </template>
                </v-select>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col w-full md:mb-0">
              <ValidationProvider vid="name" name="name" rules="required" v-slot="{ errors }">
                <small class="label">Name</small>
                <vs-input v-model="createForm.name"  name="name" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="line1" name="line1" rules="required" v-slot="{ errors }">
                <small class="label">Address Line 1</small>
                <vs-input v-model="createForm.line1"  name="line1" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="line2" name="line2" rules="" v-slot="{ errors }">
                <small class="label">Address Line 2</small>
                <vs-input v-model="createForm.line2"  name="line2" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="line3" name="line3" rules="" v-slot="{ errors }">
                <small class="label">Address Line 3</small>
                <vs-input v-model="createForm.line3"  name="line3" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="town_state" name="town_state" rules="required" v-slot="{ errors }">
                <small class="label">Town / State</small>
                <vs-input v-model="createForm.town_state"  name="town_state" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="post_code" name="post_code" rules="required" v-slot="{ errors }">
                <small class="label">Postal Code</small>
                <vs-input v-model="createForm.post_code"  name="post_code" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="country" name="country" rules="required" v-slot="{ errors }">
                <small class="label">Country</small>
                <v-select :filter-by="myFilter" :clearable="false" name="country" placeholder=""
                          label="name" v-model="createForm.country" :reduce="option => option.name"
                          :options="countryCodes" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>
<!--          <div class="vx-row mb-3">-->
<!--            <div class="vx-col md:w-full w-full md:mb-0">-->
<!--              <ValidationProvider vid="formulation_items" name="formulation_items" rules="required" v-slot="{ errors }">-->
<!--                <small class="label">Finished products</small>-->
<!--                <v-select-->
<!--                  @search="onSearch"-->
<!--                  :clearable="false" multiple name="formulation_items" placeholder=""-->
<!--                  label="formulation_code" v-model="createForm.formulation_items" :reduce="option => option"-->
<!--                  :options="formulations" :dir="$vs.rtl ? 'rtl' : 'ltr'">-->
<!--                  <template slot="no-options">-->
<!--                    type to search products-->
<!--                  </template>-->
<!--                  <template slot="option" slot-scope="option">-->
<!--                    <div class="d-center">-->
<!--                      <span style="font-weight: bold">{{ option.formulation_code }}</span> <br>-->
<!--                      <small>{{ option.description }}</small>-->
<!--                    </div>-->
<!--                  </template>-->
<!--                  <template slot="selected-option" slot-scope="option">-->
<!--                    <div class="selected d-center">-->
<!--                      {{ option.formulation_code }}-->
<!--                    </div>-->
<!--                  </template>-->
<!--                </v-select>-->
<!--                <span class="text-danger text-sm">{{ errors[0] }}</span>-->
<!--              </ValidationProvider>-->
<!--            </div>-->
<!--          </div>-->

          <div class="vx-row mb-3" v-if="createForm.customer">
            <div class="vx-col w-full">
              <ValidationProvider vid="sale_quote_id" name="sale_quote_id" rules="" v-slot="{ errors }">
                <small class="label">Sale quotes</small>
                <v-select
                  name="sale_quote_id" placeholder=""
                  :reduce="option => option.id"
                  label="quote_code"
                  v-model="createForm.sale_quote_id"
                  :options="sales_quote_list" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                </v-select>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col w-full">
              <ValidationProvider vid="feedback" name="feedback" rules="" v-slot="{ errors }">
                <small class="label">Sample Feedback</small>
                <vs-textarea class="mb-0" v-model="createForm.feedback" height="50px" />
                <span class="text-danger text-xs mt-0">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col w-full">
              <ValidationProvider vid="sale_quote_id" name="sale_quote_id" rules="" v-slot="{ errors }">
                <small class="label">Product specs send to</small>
                <v-select
                  name="sale_quote_id" placeholder=""
                  label="name" multiple
                  :reduce="option => option.value"
                  v-model="createForm.recipient_emails"
                  :options="email_list" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                </v-select>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col w-full">
              <ValidationProvider vid="customers_order_number" name="customers_order_number" rules="" v-slot="{ errors }">
                <small class="label"> Customer PO Number</small>
                <vs-input v-model="createForm.customers_order_number"  name="customers_order_number" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col w-full">
              <ValidationProvider vid="delivery_instruction" name="delivery_instruction" rules="" v-slot="{ errors }">
                <small class="label">Delivery Instructions</small>
                <vs-textarea class="mb-0" v-model="createForm.delivery_instruction" height="100px" />
                <span class="text-danger text-xs mt-0">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col w-full">
              <ValidationProvider vid="notes" name="notes" rules="" v-slot="{ errors }">
                <small class="label">Notes</small>
                <vs-textarea class="mb-0" v-model="createForm.notes" height="100px" />
                <span class="text-danger text-xs mt-0">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>
          

          <!-- Save & Reset Button -->
          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button button="submit" class="ml-auto mt-2">Save Changes</vs-button>
            <vs-button @click="createForm = {}" class="ml-4 mt-2" type="border" color="warning">Reset</vs-button>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </vs-popup>
</template>

<script>
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  const CustomerRepository = RepositoryFactory.get('customer')
  const SupplierManufactureRepository = RepositoryFactory.get('supplierManufacture');
  const FormulationsRepository = RepositoryFactory.get('formulations');
  const CrmRepository = RepositoryFactory.get('crm');
  const DropdownRepository = RepositoryFactory.get('drop_down');
  
  import vSelect from 'vue-select'
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'

  function initialState() {
    return {
      open: false,
      id: '',
      createForm: {

      },
      countryCodes: [],
      customerUsers: [],
      isCreateFromMainMenu: false,
      customers: [],
      formulations: [],
      addresses: [],
      sales_quote_list: [],
      selectedAddress: {},
      email_list: []
    }
  }

  export default {
    name: 'GeneratePdfSampleOrderPopUp',
    data () {
      return initialState()
    },
    methods:{
      async openPopup (id) {
        try {
          await Object.assign(this.$data, initialState())
          this.id = id
          await this.getCountryCodes()
          await this.getSalesQuotes()
          await this.getSampleOrder()
          await this.getAddresses()
          await this.fetchEmailList()
          // await this.getFormulations()
          this.open = true;
        } catch (error) {

        }
      },
      async onClickCreateSampleOrder () {
        const vue = this;
        this.$vs.loading()
        try {
          const payload = {
            name: this.createForm.name,
            line1: this.createForm.line1,
            line2: this.createForm.line2,
            line3: this.createForm.line3,
            town_state: this.createForm.town_state,
            post_code: this.createForm.post_code,
            country: this.createForm.country,
            sale_quote_id: this.createForm.sale_quote_id,
            delivery_instruction: this.createForm.delivery_instruction,
            notes: this.createForm.notes,
            customers_order_number: this.createForm.customers_order_number,
            feedback: this.createForm.feedback,
            recipients: this.createForm.recipient_emails.map(x=> ({
              id: x,
              type: this.createForm.customer ? 'customer' : (this.createForm.customer_lead ? 'lead' : null)
            })),
            sample_order_items: this.createForm.formulation_items.map(x => ({
              formulation_id: x.formulation_id,
              id:x.id,
              quantity: x.quantity,
              price: x.price
            }))
          }

          await CustomerRepository.updateCustomerSampleOrder(this.id, payload)
          this.showSuccessMessage('Sample order update successfully')
          await vue.$parent.refreshData()
          this.open = false;
        }catch (e) {
          this.$vs.loading.close()
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close()
      },
      async getFormulations() {
        this.$vs.loading()
        const {data} = await FormulationsRepository.get(1, '', 50, '')
        this.formulations =  data.data
        this.$vs.loading.close()
      },
      async getSampleOrder() {
        this.$vs.loading()
        const {data} = await CustomerRepository.getCustomerSampleOrder(this.id)
        this.createForm = {
          ...data.data,
          recipient_emails: data.data.recipients.map(x => x.user_id)
        }
        this.createForm.sale_quote_id = data.data.sale_quote && data.data.sale_quote.id ? data.data.sale_quote.id : null
        this.$vs.loading.close()
      },
      async getCountryCodes() {
        this.$vs.loading()
        this.countryCodes = (await SupplierManufactureRepository.getCountryCodes()).data.data;
        this.$vs.loading.close()
      },
      async getAddresses() {
        this.$vs.loading()
        try {
          if(this.createForm.customer) {
            this.addresses = (await CustomerRepository.getSampleDeliveryAddresses(this.createForm.customer.id)).data.data;
          }
          if(this.createForm.customer_lead) {
            this.addresses = (await CrmRepository.getLeadAddressList(this.createForm.customer_lead.id)).data.data
          }
        } catch (error) {
          
        }
        this.$vs.loading.close()
      },
      async fetchEmailList() {
        try {
          if(this.createForm.customer) {
            const { data } = (await DropdownRepository.getCustomerUsersDropdownList(this.createForm.customer.id)).data
            this.email_list = data.map((x) => ({name: x.email, value: x.id }))
          }
          if(this.createForm.customer_lead) {
            const { data } = (await CrmRepository.getMerketingLeadDetails(this.createForm.customer_lead.id)).data
            this.email_list = [ { name: data.email, value: data.id } ]
          }

        } catch (error) {

        }
      },
      async getSalesQuotes() {
        this.$vs.loading()
        this.sales_quote_list = (await DropdownRepository.getAllSalesQuotesList()).data.data;
        this.$vs.loading.close()
      },
      onChangeSelectDeliveryAddress(selected) {
        this.createForm.name = selected.name
        this.createForm.line1 = selected.line1
        this.createForm.line2 = selected.line2
        this.createForm.line3 = selected.line3
        this.createForm.town_state = selected.town_state
        this.createForm.post_code = selected.post_code
        this.createForm.country = selected.country
      },
      myFilter: (option, label, search) => {
        let temp = search.toLowerCase();
        return option.name.toLowerCase().indexOf(temp) > -1 ||
          option.isd_code.toLowerCase().indexOf(temp) > -1
      },
      doCheckItems(data) {

      },
      onSearch(search, loading) {
        if(search.length) {
          loading(true);
          this.search(loading, search, this);
        }
      },
      search: _.debounce( async (loading, search, vm) => {
        const {data} = await CustomerRepository.getSampleList(null, 1, `filter[search]=${search}`, 50, '')
        vm.formulations = data.data
        loading(false);
      }, 350)


    },
    async mounted () {

    },
    computed: {

    },
    components: {
      'v-select': vSelect,
    },
    mixins: [SuccessMessage, ErrorMessages],
  }
</script>

<style scoped>
  .customer-sample-order-create-popup >>> .vs-popup {
    /*min-height: 50% !important;*/
    min-width: 40% !important;
  }
  .loader {
    text-align: center;
    color: #bbbbbb;
  }

</style>
